import { useCallback, useEffect } from 'react'
import { useNavigate } from 'react-router-dom'
import Iframe from 'shared/components/Iframe'
import { useIframe } from 'shared/hooks'
import useStyleMaps from 'site/Renderer/hooks/useStyleMap'
import { AuthenticationProps } from './Authentication.types'

type EventDataMessage = {
  token?: string
}

export const getRedirectOriginURL = (redirectOrigin: string): URL => {
  try {
    return new URL(redirectOrigin)
  } catch {
    return new URL(redirectOrigin, window.location.origin)
  }
}

const Authentication = ({ props }: AuthenticationProps) => {
  const navigate = useNavigate()

  const styleProps = useStyleMaps(props.styleMap)

  const waAuthenticationUrl = window.waAuthenticationUrl

  const iframeSearchParams = new URLSearchParams()
  if (props.signUpPath) {
    iframeSearchParams.set('signUpPath', props.signUpPath)
  }
  if (props.recoverPasswordPath) {
    iframeSearchParams.set('recoverPasswordPath', props.recoverPasswordPath)
  }

  const { iframeAttributes, receiveMessage } = useIframe({
    origin: waAuthenticationUrl,
    src: `${waAuthenticationUrl}?${iframeSearchParams.toString()}`,
    title: 'Authentication'
  })

  const onReceivedMessage = useCallback(
    (event: MessageEvent) => {
      receiveMessage(event)

      const { token }: EventDataMessage = event.data

      if (token) {
        const redirectOriginURL = getRedirectOriginURL(props.redirectOrigin)

        redirectOriginURL.searchParams.set('token', token)

        navigate({
          pathname: redirectOriginURL.pathname,
          search: redirectOriginURL.search
        })
      }
    },
    [navigate, props.redirectOrigin, receiveMessage]
  )

  useEffect(() => {
    window.addEventListener('message', onReceivedMessage)
    return () => window.removeEventListener('message', onReceivedMessage)
  }, [onReceivedMessage])

  if (!iframeAttributes) {
    return null
  }

  return <Iframe {...iframeAttributes} style={styleProps} />
}

export default Authentication
